import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"

import Select from "components/Select/Select"
import { ISelectOption } from "./SelectSearch"
import DeliveryTerm from "models/DeliveryTerm"

export interface ISelectDeliveryTermProps {
    deliveryTerms?: DeliveryTerm[]
    selectedDeliveryTermId?: string
    isInvalid?: boolean
    isDisabled?: boolean
    isInModal?: boolean
    onChange(deliveryTerm?: DeliveryTerm): void
}

const SelectDeliveryTerm: FC<React.PropsWithChildren<ISelectDeliveryTermProps>> = ({
    deliveryTerms,
    selectedDeliveryTermId,
    isInvalid,
    isDisabled,
    isInModal,
    onChange,
}) => {
    const { t } = useTranslation()

    const value = useMemo(() => {
        if (!deliveryTerms || !selectedDeliveryTermId) return
        return deliveryTerms?.find(dt => dt.termId === selectedDeliveryTermId)
    }, [deliveryTerms, selectedDeliveryTermId])

    const options = useMemo<ISelectOption<DeliveryTerm>[]>(() => {
        return deliveryTerms?.map(dt => ({
            label: formatOptionLabel(dt),
            value: dt,
        })) || []
    }, [deliveryTerms])

    function handleChange(option: ISelectOption<DeliveryTerm> | undefined) {
        onChange(option?.value)
    }

    function formatOptionLabel(deliveryTerm?: DeliveryTerm) {
        return deliveryTerm ? deliveryTerm.print() : ""
    }

    return (
        <Select
            defaultValue={value ? { label: formatOptionLabel(value), value } : undefined}
            onChange={handleChange}
            options={options}
            isInvalid={isInvalid}
            isClearable
            isDisabled={isDisabled || !deliveryTerms}
            isInModal={isInModal}
            placeholder={!deliveryTerms ? t("common.loading") : undefined}
            testIdPrefix="delivery-term-select"
        />
    )
}

export default SelectDeliveryTerm
